import React from 'react'
import Icon from '../atoms/Icon'
import StatisticItem from '../homePage/StatisticItem'
const StatisticBox = ({iconName,title,item1,item2,item3,item1_num,item2_num,item3_num,correns}) => {
  return (
    <div className='w-19 border-2 border-gray rounded-sm bg-gray-200  '>
      <div className='flex flex-col justify-center border-gray border-2  items-center py-7.5px rounded-sm bg-white mx-.02 mt-.02 mb-0 '>
        <Icon className='w-14.5 h-14.5' iconName={iconName}/>
        <p className='text-14 leading-6 text-dark-blue-200 mt-3.5'>{title} {correns && <span className='text-12'>(ریال)</span>}</p>
      </div>
      <div className='flex w-full flex-col py-3.5 gap-2.5'>
       <StatisticItem name={item1} number={item1_num}/>
       <StatisticItem name={item2} number={item2_num}/>
       <StatisticItem name={item3} number={item3_num}/>
       
      </div>
    </div>
  )
}

export default StatisticBox
